export default __webpack_public_path__ + "static/media/Card_Payment.73da5a19.svg";